<geaui-page-content-layout-v3>
  <ng-container page-header>
    <div class="header-fixed">
      <geaui-page-header-v3 [hasBackArrow]="true" [withSidebar]="true" (backArrowClicked)="goBack()" pageTitle="{{ fileName }}">
      </geaui-page-header-v3>
    </div>
  </ng-container>

  <ng-container page-content>
    <div class="scroll-wrapper">
      <div class="data-maintenance-content-container geaui-sidebar-grid geaui-scrollable-table">
        <geaui-table-v3
          [tableId]="tableId"
          [persistSettings]="false"
          [columnDefinitions]="dataContentColumnDefinitions"
          [data]="filteredData"
          [totalRecords]="count"
          [isLandingPage]="true"
          [sortable]="true"
          [loading]="isTableLoading()"
          [noEntriesInfoText]="'No entries available yet'"
          [noEntriesActionText]="'Create new entry'"
          [noEntriesActionIcon]="'_sort'">
        </geaui-table-v3>
      </div>
    </div>
  </ng-container>

  <ng-container page-footer>
    @if (canReplaceFile) {
      <geaui-page-footer class="footer" [backgroundColor]="'white'" [withSidebar]="true">
        <ng-container footer-button>
          <geaui-button-v3
            [disabled]="!hasUnsavedChanges() || hasValidationErrors()"
            [loading]="isSaving()"
            (click)="saveChanges()">
            Save
          </geaui-button-v3>
        </ng-container>
      </geaui-page-footer>
    }
  </ng-container>
</geaui-page-content-layout-v3>
